/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnalyticsEvent, PianoEvent } from "@models/analytics-event";
import UpdateStatusService from "@services/update-status-service";
import breakpoints from "@utils/breakpoints";
import { getSingleInstanceByElement, initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { notifyFromAlert } from "../helpers/notifs";
import { hw } from "../helpers/paths";
import Selector from "../multiselect/select";
import DataSerp from "./serp-dynamic";
import {
  OFFER_RESPONSE_STATUS,
  isDisabledStatus,
  META_STATUS_DISPLAYED,
  CANDIDATE_RESPONSE_TYPE,
  META_STATUS
} from "./status";

/**
 * Reference des objets provenant du back -> Mes candidature
 */

/**
 * Reponse retourné par le back après avoir répondu à une question
 */
interface WebUpdateResponse {
  offerResponse: object
  metaStatutId: number
  metaStatutLabel: string
  questionsActions: object
}

/**
 * Object contenant les informations liées à une réponse 
 */
interface WebResponse {
  responseType: number
  label: string
}

/**
 * Object contenant les informations liées à une question 
 */
interface WebQuestion {
  questionType:number
  responses: WebResponse[]
  Label: string
}

/**
 * Objet contenant les informations relatives aux questions de la RO
 */
interface WebQuestionsActions {
  questions: WebQuestion
  requestedAction?: number
  errorMessage: string
}

interface SerpOfferProps {
    serp: string
    idx: string
}

export default class SerpOffer extends Component {
  private tagQuerySelector = ".ls-tag-candidature";

  private idx: number;
  private done = false;
  private id: string;
  private type: string;
  private metaStatusId: number;
  private status: string;
  private url: string;
  private statusSelector: Selector;
  private data: {[key:string]: any};
  private minHeight: number;
  private mutationObserver: MutationObserver;
  private hasCompanyLink = false;
  private force = false;
  private questionsActions: WebQuestionsActions

  constructor(private props: SerpOfferProps, element: HTMLElement) {
    super(props, element);
    this.idx = parseInt(props.idx);
  }

  mounted(): void {
    this.injectTemplate();

     const serp = this.element.parentElement;

     if (this.element.hasAttribute("data-type")) {
       this.type = this.element.getAttribute("data-type");
     }
     const serpInstance: DataSerp = getSingleInstanceByElement("DataSerp", serp);
     this.populate(serpInstance);
  }
  populate(serp:DataSerp): void {
      if(this.done) {
          return;
      }
      const data = serp.data;
      if(data) {
        if (window.matchMedia(breakpoints.md).matches) {
          this.force = true;
          this.updateOfferHeightWhenQuestionIsLoaded("[data-offer-extract]");
        }
        
           if ((data.items.length) > (this.idx)) {
            if (data.items[this.idx].offerResponse) {
              this.data = data.items[this.idx].offerResponse
              this.metaStatusId = data.items[this.idx].metaStatutId
            } else {
              this.data = data.items[this.idx]
            }

            const cvLink = this.element.querySelector(".candidate .cv");

                 this.questionsActions = (data.items[this.idx].questionsActions?.questions) ? data.items[this.idx].questionsActions : undefined;

                 this.id = this.data["id"];
                 if(serp.url) {
                     this.url = serp.url;
                 }

                 const attrs = this.element.querySelectorAll("[data-attr]");
                 for (let i = 0; i < attrs.length; i++) {
                   let js:any = attrs[i].getAttribute("data-attr");
                   try {
                     js = JSON.parse(js);
                   } catch (e) {
                     const tmp: any = [{}];
                     tmp[0].attr = "innerText";
                     tmp[0].value = js;
                     js = tmp;
                   }
                   for (let j = 0; j < js.length; j++) {
                     if (this.data[js[j].value]) {
                       if (js[j].attr && js[j].attr != "innerText") {
                         const value = this.data[js[j].value];
                         attrs[i].setAttribute(
                           js[j].attr,
                           value && typeof value !== "string"
                             ? JSON.stringify(value)
                             : value
                         );
                       } else {
                         (<HTMLElement>attrs[i]).innerText = this.data[js[j].value];
                       }
                     } else {
                       if (js[j].attr && js[j].attr != "innerText") {
                         attrs[i].setAttribute(js[j].attr, "");
                       } else {
                         (<HTMLElement>attrs[i]).innerText = "";
                       }
                     }
                   }
                 }

                  const headerMessage = this.element.querySelector(
                    "span.header-message"
                  );

                  if (this.data.infoMessage || 
                    this.data.offerResponseStatus === OFFER_RESPONSE_STATUS.SeenByRecruiter || 
                    this.data.offerResponseStatus === OFFER_RESPONSE_STATUS.RejectedByRecruiter) {
                    headerMessage.classList.add("info-message");
                    if (this.data.infoMessage?.level === "Info") {
                      headerMessage.classList.add("info");
                    } else if (this.data.infoMessage?.level === "Warning") {
                      headerMessage.classList.add("warning");
                    } else if (this.data.infoMessage?.level === "Error") {
                      headerMessage.classList.add("error");
                    }

                    headerMessage.innerHTML = 
                      `<svg data-load-url="${hw.getBaseRessourcesUrl()}/img/svg/exclamation-mark.svg" class="tw-inline tw-size-4 tw-mr-2"></svg>`;

                    if (this.data.infoMessage?.content) {
                      if (this.data.infoMessage.content === "Déjà postulé") {
                        // Tag affiché dans la liste des favoris
                        const spanAlready = document.createElement("span"); 
                        spanAlready.classList.add("info");
                        spanAlready.classList.add("already");
                        spanAlready.classList.add("apply");
                        spanAlready.innerText = this.data.infoMessage.content;
                        this.element
                          .querySelector("span.company.entname")
                          .append(spanAlready);
                        headerMessage.remove();
                      } else {
                        // Tag affiché dans la liste des candidatures
                        headerMessage.innerHTML +=
                          this.data.infoMessage.content;
                      }
                    }

                    if (this.data.offerResponseStatus === OFFER_RESPONSE_STATUS.SeenByRecruiter || this.data.offerResponseStatus === OFFER_RESPONSE_STATUS.RejectedByRecruiter) {
                      if (this.data.infoMessage) {
                        const secondHeaderMessage = document.createElement("span")
                        secondHeaderMessage.classList.add("header-message", "info-message", "info", "seen");
                        secondHeaderMessage.innerHTML = "Candidature consultée par le recruteur";
                        headerMessage.after(secondHeaderMessage);
                      } else {
                         headerMessage.classList.add("info", "seen");
                         headerMessage.innerHTML = "Candidature consultée par le recruteur";
                      }
                    }

                    if (this.data.offerResponseStatus === OFFER_RESPONSE_STATUS.ErrorMarvin) {
                      cvLink.classList.add("tw-pointer-events-none", "tw-opacity-40")
                    }

                    initialiseComponents();
                  }

                this.displayCompanyLink();

                const bookmark = this.element.querySelector("span[bookmark]");
                bookmark.setAttribute("bookmark", bookmark.getAttribute("bookmark").replace("###", this.id));
                bookmark.setAttribute("bookmark", bookmark.getAttribute("bookmark").replace("$$", data.idApp));
                bookmark.setAttribute("data-bookmark", bookmark.getAttribute("bookmark"));
                if (this.data["isBookmarked"]) {
                    bookmark.classList.add("bookmarked");
                }
                if (this.type !== "responses") {
                    const offer = this.element.querySelector("div[data-offer-extract]");
                    offer.setAttribute("data-for", this.id + "-" + this.data["randomId"]);
                }
                const link = this.element.querySelector("a[data-click]");
                link.setAttribute("id", this.id + "-" + this.data["randomId"]);

                // Add GA events
                if (data.trackingsLoad && data.trackingsLoad.length &&
                    data.trackingsLoad[0].ecommerce &&
                    data.trackingsLoad[0].ecommerce.impressions) {
                    const itemTracking = data.trackingsLoad[0].ecommerce.impressions[this.idx];
                    if (itemTracking) {
                        link.setAttribute("data-click", JSON.stringify(itemTracking));
                    }
                }

                 const now = new Date();
                 const nowD = now.getDay();
                 const nowTime = new Date().getTime();
                 const dt = new Date(this.data["publishDate"]);
                 const dtD = dt.getDay();
                 const dateText =
                   dt.getDate() +
                   "/" +
                   ((dt.getMonth() + 1 < 10 ? "0" : "") + (dt.getMonth() + 1)) +
                   "/" +
                   dt.getFullYear();
                 const dtTime = nowTime - dt.getTime();

                 const mapping = [
                   { dif: "15000", text: "Il y a un instant" },
                   { dif: "60000", text: "Il y a moins d'une minute" },
                   { dif: "120000", text: "Il y a environ une minute" },
                   {
                     dif: "3600000",
                     text: "Il y a " + Math.floor(dtTime / 60000) + " minutes",
                   },
                   { dif: "4800000", text: "Il y a 1 heure" },
                   {
                     dif: "86400000",
                     text:
                       nowD == dtD
                         ? "Il y a " +
                           Math.floor(dtTime / 60000 / 60) +
                           " heures"
                         : "Hier",
                   },
                 ];

                 let timeText: string;
                 for (let i = 0; i < mapping.length && !timeText; i++) {
                   if (dtTime < parseInt(mapping[i].dif)) {
                     timeText = mapping[i].text;
                   }
                 }
                 if (!timeText) {
                   timeText = dateText;
                 }

                 if (this.type !== "responses" && this.data.tipsMessage) {
                   this.element.querySelector<HTMLElement>("span.message").innerText =
                     this.data.tipsMessage;
                 }

                 const tag = this.element.querySelector<HTMLElement>(this.tagQuerySelector);
                 if (this.type === "responses") {
                   this.status = this.data.metaStatutLabel
                   if (this.status !== "") {
                     
                     // Mise à jour du statut
                    this.updateStatusDisplayed();
                    // Display question if needed
                    this.askApplicationStatus();

                    // Disable what is needed
                    this.disableOffer();

                    const changeStatus = () => {
                      const newStatus = this.statusSelector.getValue();
                      if (newStatus && newStatus.length && newStatus[0] !== this.status) {
                        this.updateStatus(newStatus[0], () => {
                          // Display question if needed
                          this.askApplicationStatus();
                        });
                      }
                    }

                    PubSub.subscribe("status-changed", (msg:string, instance:Selector) => {
                        if(instance.getElement() === tag) {
                          changeStatus()
                        }
                    });
                   } 

                   if (this.data["applyDate"]) {
                     const date = new Date(this.data["applyDate"]);
                     if (date) {
                       const span =
                         this.element.querySelector<HTMLElement>("span.responseDate");
                       let text =
                         "Envoyée le " +
                         date.toLocaleDateString("fr-FR", {
                           month: "long",
                           day: "numeric",
                         });

                       const year = new Date().getFullYear();
                       if (date.getFullYear() !== year) {
                         text += " " + date.getFullYear();
                       }

                       span.innerText = text;
                     }
                   }
                 } else {
                  tag.remove();
                 }
                 if (this.data.cvUrl) {
                  cvLink.innerHTML = '<a href="' + this.data.cvUrl + '" target="_blank">' +
                            '<svg data-load-url="' + hw.getBaseRessourcesUrl() + '/img/svg/download.svg"></svg>Mon CV' +
                            "</a>";
                 }
                 if (this.data.coverLetter) {
                    this.displayCoverLetter();
                }
                 this.element.querySelector("span.time").innerHTML = timeText;

                 if (this.data["IsNewForUser"]) {
                   const title = this.element.querySelector(".title");
                   title.classList.add("new");
                   title.innerHTML += " <span>Nouveau</span>";
                 }
                 
                 const response = data.items[this.idx];
                 if (response.isAiContentEnabled) {
                   const { offerId, id: offerResponseId } = response.offerResponse || {};
    
                   const globalContainerDiv = this.element.querySelector(`[data-offerid="${offerResponseId}"]`);
                   if (!globalContainerDiv) return;
    
                   const [aiContainer, aiButton] = [
                     globalContainerDiv.querySelector("[data-interview-container]"),
                     globalContainerDiv.querySelector("[data-interview-button]")
                   ];
    
                   if (aiContainer) {
                     aiContainer.setAttribute("data-analytics-values-param",JSON.stringify(response?.interviewLoadCTATracking));
                     aiContainer.removeAttribute("hidden");
                   }
    
                   if (aiButton) {
                     aiButton.setAttribute("data-analytics-values-param",JSON.stringify(response?.interviewOpenModalTracking));
                     aiButton.addEventListener("click", () => this.displayAiModal(offerId));
                   }
                 }

                 initialiseComponents();
           }
           this.done = true;
      }
  }
  
  private displayAiModal(offerId: string): void {
      const frame = document.querySelector('turbo-frame#interviewModalFrame');
      if (frame) {
        // Turbo se chargera automatiquement de mettre à jour le contenu de la frame
        frame.setAttribute("src", `/OfferResponseDetail/GetAiModalContentFrameView?offerId=${offerId}`);
      }
  }

  private displayCompanyLink(newMetaStatutsId?: number) {
      // Add company link if available and in case of interview to come
      let isInterviewStatus;
      if (newMetaStatutsId) {
        isInterviewStatus = newMetaStatutsId === META_STATUS.PlannedInterview;
      } else {
        isInterviewStatus = this.metaStatusId === META_STATUS.PlannedInterview;
      }
      const isNotNullcompanyLink = this.data.companyLink;

      if (isInterviewStatus && isNotNullcompanyLink) {
          this.hasCompanyLink = true;
          const companyLink = document.createElement("div");
          companyLink.classList.add("company-link");
          companyLink.innerHTML = '<a href="' + this.data.companyLink + '" target="_blank">Mieux connaitre l’entreprise, préparez-vous' +
              '<svg data-load-url="' + hw.getBaseRessourcesUrl() + '/img/svg/nav/arrow-right.svg"></svg></a>';
          this.element.querySelector("[data-offer-extract]").appendChild(companyLink);
      }
  }

  private askApplicationStatus(): void {
    this.removeQuestion();
    if (this.questionsActions) {
      this.askQuestion();
    }
  }

  private disableOffer():void {
    if (this.data.isOnline === false 
      || this.status === "SmartApplyExpiredOffer") {
        this.element.querySelector("[data-offer-extract]").classList.add("disabled");
        this.element.querySelector("[data-offer-extract]").classList.remove("hoverable");
    } else if (isDisabledStatus(this.getStatusId())) {
        this.element.querySelector(".actions [data-select]").classList.add("disabled");
    }
  }

  private updateStatus(status: number, successCallback: () => void, errorCallback?: () => void): void {
    const service = new UpdateStatusService(this.url);
    const data = {
      "idOfferResponse": this.id,
      "offerResponseResponseType": status
    };
    service.put(data, (reponse: WebUpdateResponse) => {
        this.status = reponse.metaStatutLabel
        this.updateStatusDisplayed(reponse.metaStatutId)
        this.displayCompanyLink(reponse.metaStatutId)
        successCallback()
    })
    service.setErrorHandler(() => {
      notifyFromAlert({
              "Icon": 2,
              "Message": "Aïe, une erreur est survenue, rechargez la page et réessayez.",
              "AnalyticsTrackings": "",
              "sticky": true
      }, true);
      if (errorCallback) {
        errorCallback();
      }
    });
  }

  /**
   * @returns status id or 0 for unknow
   */
  private getStatusId(): number {
    for(const [key, value] of Object.entries(OFFER_RESPONSE_STATUS)) {
      if (this.status === key) return value;
    }
    return 0;
  }

  private updateStatusDisplayed(newMetaStatutsId?: number): void {
    const tag = this.element.querySelector<HTMLElement>(this.tagQuerySelector);
    const tagIcon = tag.querySelector<HTMLElement>(this.tagQuerySelector + "__icon");
    const tagText = tag.querySelector<HTMLElement>(this.tagQuerySelector + "__text");
    // On retire la class de couleur actuelle
    tagIcon.classList.remove(META_STATUS_DISPLAYED[this.metaStatusId].color)
    // On ajoute la class de couleur courante
    tagIcon.classList.add(META_STATUS_DISPLAYED[newMetaStatutsId ?? this.metaStatusId].color)
    tagText.innerHTML = `${this.status ?? 'En erreur'}`;
  }

  private setHeight(question: HTMLDivElement) {
    if (question && this.minHeight <= question.clientHeight) {
      this.element.style.height = `${question.clientHeight}px`;
    } else {
      this.element.style.height = `${this.minHeight}px`;
    }
  }

  /**
   * initialise la limite de hauteur de l'offre
   */
  private setMinHeight() {
    this.minHeight = (this.force && this.hasCompanyLink) ? this.element.clientHeight + 35 : this.element.clientHeight;
  }

  /**
   * renitialise la hauteur de l'offre
   */
  private resetHeight() {
    this.element.style.height = `${this.minHeight}px`;
  }

  /**
   * retire la limite de hauteur de l'offre
   */
  private clearHeight() {
    this.element.style.height = ``;
  }


  /** 
   * Affiche la coverLetter quand elle est présente
  */
  private displayCoverLetter() {
    if (this.data.coverLetter) {
      const letterSpan = this.element.querySelector(".candidate .letter");
      const callbackAfterEvent = () => {
        const question = (this.element as HTMLElement).querySelector<HTMLDivElement>('.data-offer-message');
        letterSpan.classList.toggle("closed");
        if(letterSpan.classList.contains("closed")) {
          this.setHeight(question);
        } else {
          this.clearHeight()
        }
        
      }
      letterSpan.innerHTML =
      'Message envoyé<svg data-load-url="' + hw.getBaseRessourcesUrl() + '/img/svg/down.svg"></svg>';
      letterSpan.addEventListener("click", callbackAfterEvent);
      this.element.querySelector(".candidate .letter-content").innerHTML = this.data.coverLetter;
    }
  }
  /**
   * Force la fermeture de la candidature
   */
  colapseCoverLetter() {
    const letterSpan = this.element.querySelector(".candidate .letter");
    if (letterSpan && !letterSpan.classList.contains("closed")) {
      letterSpan.classList.add("closed");
    }
  }

  private updateOfferHeightWhenQuestionIsLoaded(queryString?: string): void {
    let element = this.element;
    if(queryString) {
      element = this.element.querySelector(queryString);
    }

    const eachOfferElementChange = (record: MutationRecord[]): void => {
      const offer = <HTMLLIElement>record[0].target;
      const question = offer.querySelector<HTMLDivElement>('.data-offer-message');
      if (question !== null || this.force) {
        this.setMinHeight();
        this.setHeight(question);
        this.force = false;
        if (question !== null) this.mutationObserver.disconnect();
      }
    }

    this.mutationObserver = new MutationObserver(eachOfferElementChange.bind(this));
    this.mutationObserver.observe(element, { childList: true });
  }
  private askQuestion() {
    if (window.matchMedia(breakpoints.md).matches) {
      this.updateOfferHeightWhenQuestionIsLoaded();
    }
    const questionCard = document.createElement("div");
    questionCard.classList.add(...["data-offer-message","tw-px-4","tw-py-6","tw-flex","tw-flex-col"]);

    // Question title
    const title = document.createElement("div");
    title.innerHTML = this.questionsActions.questions.Label;
    title.classList.add("data-offer-message-title");
    questionCard.appendChild(title);
    // If question has choises
    if (this.questionsActions.questions.responses) {
      this.addResponse(questionCard);
    }
    // Add question to offer
    this.element.appendChild(questionCard);
    initialiseComponents();
  }

  private addResponse(questionCard: HTMLDivElement): void {
    this.questionsActions.questions.responses.forEach((response, index) => {
      const choiceElement = document.createElement("div");
      choiceElement.classList.add(...['tw-flex','tw-items-center', 'tw-py-2'])
      const id = `radio${index}${this.data.id}`
      choiceElement.innerHTML = `
        <input
          type="radio"
          id="${id}"
          name="radio"
          value="${response.responseType}"
          class="tw-radio tw-min-w-5 tw-bg-white"
        >
        <label for="${id}">
          ${response.label}
        </label>
      `;
      const label = choiceElement.querySelector(`label[for="${id}"]`);
      label.closest("div").addEventListener("click", () => {
        if (CANDIDATE_RESPONSE_TYPE[response.responseType].label === 'DidYouHaveFeedback_Recruited,' && document.getElementById('celebration-modal')) {
          (document.getElementById('celebration-modal') as HTMLInputElement).checked = true
        }
        // Save current status
        const formerCandidateStatus = this.data.offerResponseCandidateStatus;
        PubSub.publish("status-changed", this)
        this.updateStatus(
          response.responseType,
           () => {
            this.setClickTracking(
              this.setTracking(
                CANDIDATE_RESPONSE_TYPE[response.responseType].tracking.name, 
                CANDIDATE_RESPONSE_TYPE[response.responseType].tracking.info
              )
            );
            this.removeQuestion();
            this.colapseCoverLetter();
          },
          () => {
            // In case of error, set back former status
            this.data.offerResponseStatus = formerCandidateStatus;
          }
        );
      });
      questionCard.appendChild(choiceElement);
    }) 
  }

  private removeQuestion() {
    const questionFound = this.element.querySelector('.data-offer-message');
    if (questionFound) {
      this.element.removeChild(questionFound);
      this.resetHeight();
    }
  }


  private setTracking(event_name: string, event_info : string = "", event_value: string = ""): PianoEvent {
    return {
      event_name,
      event_info,
      event_value
    };
  }

  private setClickTracking(track: PianoEvent): void {
    if (this.data.trackingsClick && this.data.trackingsClick.length) {
      const trackingsClick: AnalyticsEvent = this.data.trackingsClick[0];
      trackingsClick.event = "EventGeneric";
      trackingsClick.EventAction = 'click';
      trackingsClick.EventCat = "Question";
      trackingsClick.EventLibelle = track.event_info;
      trackingsClick.EventName = track.event_name;
      trackingsClick.event_value = track.event_value;
      window.dataLayer.push(trackingsClick);
    }
  }
}

